import React from'react';
import GoogleDocsViewer from 'react-google-docs-viewer';
//import { useParams } from "react-router-dom";
import { Utils } from '../../common';  

const DocViewer = ({doc}) => {

  //const { doc } = useParams();

  let height = window.innerHeight-167;

  if(height < 200){
    height = 200;
  }

  return <GoogleDocsViewer
    width="100%"
    height={height}
    fileUrl={Utils.viewerLink(doc, `cqcs/downloadud/${doc}`)}
  />;
};

export default DocViewer;